import { useMediaQuery, useTheme } from '@material-ui/core';

export default function useIsDesktop() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  return isDesktop;
}
